import React from "react";
import { FaRegCompass, FaShieldAlt, FaSlidersH } from "react-icons/fa";
import card2Bg from "../../../assets/Bulk/Card2/card2.svg";
import card3Bg from "../../../assets/Bulk/Card2/card3.svg";
import card1Bg from "../../../assets/Exactness/Header/Bg.svg";
import Line from "../../../assets/line2.svg";

const cardData = [
  {
    title: "Process Large Lists",
    description:
      "Handle up to 1M+ rows at once with our fast optimized system.",
    actionText: "Domain Search",
    icon: <FaRegCompass className="text-[#39C4DC] text-xl" />,
    bgImage: card1Bg,
    color: "text-[#39C4DC]",
    bgcolor: "bg-[#EBFBFC]",
    border: "border-[#99E1ED]",
  },
  {
    title: "Comprehensive Verification",
    description:
      "We verify every email for syntax, domain, mail server, and more to keep your list clean.",
    actionText: "Campaigns",
    icon: <FaShieldAlt className="text-[#F88DA0] text-xl" />,
    bgImage: card2Bg,
    color: "text-[#F88DA0]",
    bgcolor: "bg-[#FDEBED]",
    border: "border-[#F9AFBB]",
  },
  {
    title: "Customizable Results",
    description:
      "Filter your results by what matters to you, like job titles, departments, or company size.",
    actionText: "Integrations",
    icon: <FaSlidersH className="text-[#64D1AE] text-xl" />,
    bgImage: card3Bg,
    color: "text-[#64D1AE]",
    bgcolor: "bg-[#EBFBF4]",
    border: "border-[#98E2C9]",
  },
];

const Card2 = () => {
  return (
    <>
      <h2 className="text-3xl bg-gray-50 pt-8 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:pt-16 pb-5 lg:pb-9">
        What Makes Our{" "}
        <span className="relative inline-block">
          Bulk Finder{" "}
          <img
            src={Line}
            alt="Underline decoration"
            className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
          />
        </span>{" "}
        Great
      </h2>
      <div className="grid gap-6 py-6 bg-gray-50 sm:grid-cols-2 min-[950px]:grid-cols-3 p-6">
        {cardData.map((card, index) => (
          <div
            key={index}
            className={`relative bg-white shadow-lg rounded-lg p-6 flex flex-col justify-between text-left ${
              index === 2
                ? "sm:col-span-2 min-[950px]:col-span-1 sm:mx-auto"
                : ""
            }`}
            style={{
              backgroundImage: `url(${card.bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 bg-white opacity-5"></div>
            <div className="relative z-10 flex flex-col h-full">
              <div
                className={`my-4 p-4 rounded-lg flex items-center justify-center w-12 h-12 ${card.border} border ${card.bgcolor}`}
              >
                <div className="my-4">{card.icon}</div>
              </div>
              <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
              <p className="text-gray-600 mb-4">{card.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Card2;
